import { Tabs, Card, Row, Col, Tag } from 'antd';
import React from 'react'

const CustomerBaseBidCard = ({bidData}) => {
    const organizeData = () => {
        if(bidData) {
            const structuredData = [];
            Object.keys(bidData).forEach((currency) => {
                const currencyItem = bidData[currency];
                if(currencyItem.length) {
                    structuredData.push({
                        label: currency,
                        key: currency,
                        children: <BidStatusCards bidData={currencyItem}/>
                    })
                }
            })
            
            return structuredData; 
        }             
    };

    return(
        <React.Fragment>
            <Tabs type='card' items={organizeData()} />
        </React.Fragment>
    )
}

export default CustomerBaseBidCard;


const BidStatusCards = ({bidData}) => {

    const tagColors = {
        WAITING: 'cyan',
        POSITIVE: 'green',
        NEGATIVE: 'red'       
    };

    const titles = {
        WAITING: 'BEKLEYEN TEKLİF',
        POSITIVE: 'OLUMLU TEKLİF',
        NEGATIVE: 'OLUMSUZ TEKLİF'
    };

    return(
        <React.Fragment>
            {
                bidData.map((bid, idx) => {
                    return(
                        <Row key={`bid-status-card-${idx}`} style={{marginBottom: '12px'}}>
                            <Col span={24}>
                                <Card
                                >
                                    <Card.Grid hoverable={false} style={{width: '70%'}}><Tag color={tagColors[bid.bidStatus]}>{titles[bid.bidStatus]}</Tag></Card.Grid>
                                    <Card.Grid hoverable={false} style={{width: '30%'}}><p>Adet: {bid.count}</p></Card.Grid>
                                    <div style={{display: 'flex', justifyContent:'space-evenly', flexDirection: 'column', padding: '4px 0 0 16px'}}>
                                            <p>Vergi Hariç Toplam: {new Intl.NumberFormat().format(bid.priceWithoutTax)}</p>
                                            <p>Vergi Dahil Toplam: {new Intl.NumberFormat().format(bid.priceWithTax)}</p>   
                                    </div>
                                </Card> 
                            </Col>
                        </Row>
                    )
                })
            }
        </React.Fragment>
    )
};
